import React from "react";
import { Helmet } from "react-helmet";

const SITE_URL = "https://www.comtheplug.com";
const DEFAULT_IMAGE = "/assets/img/mockup-sites.jpg";

function normalizeUrl(path) {
    if (!path) return SITE_URL;
    const cleanPath = path.startsWith("/") ? path : `/${path}`;
    return `${SITE_URL}${cleanPath}`;
}

function normalizeImage(image) {
    if (!image) return null;
    if (image.startsWith("http://") || image.startsWith("https://")) return image;
    const cleanPath = image.startsWith("/") ? image : `/${image}`;
    return `${SITE_URL}${cleanPath}`;
}

function Seo({
    title,
    description,
    path = "/",
    image = DEFAULT_IMAGE,
    preloadImage,
    preloadImages = [],
    robots,
    locale = "de_DE",
    type = "website"
}) {
    const url = normalizeUrl(path);
    const imageUrl = normalizeImage(image);
    const preloadList = [preloadImage, ...preloadImages]
        .filter(Boolean)
        .map(normalizeImage)
        .filter(Boolean);

    return (
        <Helmet>
            {title && <title>{title}</title>}
            {description && <meta name="description" content={description} />}
            {robots && <meta name="robots" content={robots} />}
            <link rel="canonical" href={url} />
            <meta property="og:locale" content={locale} />
            <meta property="og:type" content={type} />
            {title && <meta property="og:title" content={title} />}
            {description && <meta property="og:description" content={description} />}
            <meta property="og:url" content={url} />
            {imageUrl && <meta property="og:image" content={imageUrl} />}
            {preloadList.map((img) => (
                <link key={img} rel="preload" as="image" href={img} />
            ))}
        </Helmet>
    );
}

export default Seo;
